import { render } from "./URLTrigger.vue?vue&type=template&id=07df3e70"
import script from "./URLTrigger.vue?vue&type=script&lang=js"
export * from "./URLTrigger.vue?vue&type=script&lang=js"

import "./URLTrigger.vue?vue&type=style&index=0&id=07df3e70&lang=scss"
script.render = render

export default script